"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_07({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m1.08,30c-.6,0-1.08-.49-1.08-1.08v-3.3c0-.6.49-1.08,1.08-1.08h.65v-15.45h-.65c-.6,0-1.08-.49-1.08-1.08v-3.3c0-.6.49-1.08,1.08-1.08h1.71V1.08C2.79.49,3.28,0,3.88,0h2.91C7.38,0,7.87.49,7.87,1.08v2.53h2.78V1.08C10.65.49,11.14,0,11.74,0h6.52C18.86,0,19.35.49,19.35,1.08v2.53h2.78V1.08C22.13.49,22.62,0,23.21,0h2.91C26.72,0,27.21.49,27.21,1.08v2.53h1.71c.6,0,1.08.49,1.08,1.08v3.3c0,.6-.49,1.08-1.08,1.08h-.65v15.45h.65c.6,0,1.08.49,1.08,1.08v3.3c0,.6-.49,1.08-1.08,1.08H1.08Zm-.12-.96h28.07v-3.54H.96v3.54Zm1.73-4.5h24.61v-15.45H2.7v15.45ZM.96,8.12h28.07v-3.54H.96v3.54ZM23.09,3.61h3.15V.96h-3.15v2.65Zm-11.48,0h6.77V.96h-6.77v2.65Zm-7.86,0h3.15V.96h-3.15v2.65Z"
      />
      <path
        className="cls-1"
        d="m6.3,17.29c-.27,0-.48-.22-.48-.48s.22-.48.48-.48h2.89c.27,0,.48.22.48.48s-.22.48-.48.48h-2.89Z"
      />
      <path
        className="cls-1"
        d="m22.26,18.73c-.27,0-.48-.22-.48-.48v-.96h-.96c-.27,0-.48-.22-.48-.48s.22-.48.48-.48h.96v-.96c0-.27.22-.48.48-.48s.48.22.48.48v.96h.96c.27,0,.48.22.48.48s-.22.48-.48.48h-.96v.96c0,.27-.22.48-.48.48Z"
      />
      <path
        className="cls-1"
        d="m15.05,21.45c-.07,0-.13-.01-.19-.04-.24-.11-.36-.39-.25-.63l1.5-3.49h-2.94c-.17,0-.31-.08-.4-.22-.09-.14-.1-.31-.03-.46l1.89-4.16c.08-.17.25-.28.44-.28.07,0,.14.01.2.04.12.05.21.15.25.27.05.12.04.25-.01.37l-1.58,3.48h2.93c.16,0,.31.08.4.22.09.14.11.3.04.46l-1.79,4.16c-.08.18-.25.29-.44.29h0Z"
      />
    </svg>
  );
}
